import { PackType } from 'types/enums';

export const fakeSample = {
    guid: 'fake-sample-id',
    name: 'Test name',
    packId: 'pack-id',
    instrumentFamily: null,
    instruments: [
        {
            code: 'vocoder',
            subInstruments: [{ code: 'guitar_bass' }],
        },
    ],
    sampleType: null,
    key: null,
    bpm: 120,
    duration: 3000,
    pack: {
        type: PackType.Pack,
        name: 'Pack Name',
        guid: 'pack-id',
        artworkUrl: 'pack-artwork-url',
        backgroundColor: '#040404',
        foregroundColor: 'black' as 'white' | 'black',
        isFavorited: false,
        isDownloaded: false,
        isExclusive: false,
        slug: 'pack-slug',
    },
    isFavorited: true,
    isDownloaded: true,
    tags: [],
    sfxs: [],
    waveformUrl: '',
};
